import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { tap } from 'rxjs';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';

Chart.register(...registerables);
@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css'],
})
export class StatisticsComponent implements OnInit, AfterViewInit {
  chart!: any;
  chart2!: any;
  homme: number[] = [];
  femme: number[] = [];

  hommes: number[] = [];
  femmes: number[] = [];
  cities: string[] = [
    'Dakar',
    'Diourbel',
    'Fatick',
    'Hors Sénégal',
    'Kaffrine',
    'Kaolack',
    'Kolda',
    'Kédougou',
    'Louga',
    'Matam',
    'Saint-Louis',
    'Sédhiou',
    'Tambacounda',
    'Thiès',
    'Ziguinchor',
  ];
  countAdmis!: number;
  countNoAdmis!: number;
  cohorte: any = null;

  breadcrumbItems!: BreadcrumbItem[];

  constructor(private utilisaterService: UtilisateursService) { }

  ngOnInit(): void {
    this.cohorte = sessionStorage.getItem('cohorte');

    this.breadcrumbItems = [
      { label: 'SIGUI' },
      { label: `SESSION ${this.cohorte}`, url: `/dashboard/appels/candidatures/${this.cohorte}` },
      { label: 'STATISTIQUES', url: `/dashboard/appels/statistiques/${this.cohorte}` },
    ];
  }

  ngAfterViewInit(): void {
    this.getAdmittedByCityAndSexe();
    this.getCountAdmisNoadmis();
    this.generateGenderChart();
    this.generateCategoryChart();
  }

  getCountAdmisNoadmis() {
    this.utilisaterService.countAdmisNoAdmis().subscribe((data: any) => {
      // //console.log('data', data);
      this.countAdmis = data?.['coutAdmis'];
      this.countNoAdmis = data?.['countNodmis'];

      // //console.log('Données  Admis:>', this.countAdmis);
      // //console.log('Données non Admis:>', this.countNoAdmis);

      this.setTotalAdmis_NoAdmisChart(
        'canvasCountAdmisNoAdmis',
        0,
        0,
        'Répartition des admis et non admis',
        {
          Admis: 'rgba(75, 192, 192, 0.2)',
          NomAdmis: 'rgba(255, 99, 132, 0.2)',
        }
      );
    });
  }

  getAdmittedByCityAndSexe() {
    this.utilisaterService.getAdmittedByCityAndGender().subscribe((stats) => {
      this.cities.forEach((city) => {
        this.homme.push(stats[city]?.Homme);
        this.femme.push(stats[city]?.Féminin);
      });

      this.setDiagrams(
        'canvasCityAndGender',
        this.homme,
        this.femme,
        'Repartition par region et par genre',

        {
          homme: 'rgb(14, 159, 110)',
          femme: 'rgb(240, 82, 82)',
        }
      );
    });
  }

  setDiagrams(
    canvasName: string,
    maleData: number[],
    femaleData: number[],
    title: string,
    color: { homme: string; femme: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;

    const ctxIA = canvas.getContext('2d');
    if (ctxIA) {
      this.chart = new Chart(ctxIA, {
        type: 'bar',
        data: {
          labels: [
            'DK',
            'DL',
            'FK',
            'HS',
            'KF',
            'KL',
            'KD',
            'KG',
            'LG',
            'MT',
            'SL',
            'SD',
            'TA',
            'TH',
            'ZG',
          ], // Labels principaux
          datasets: [
            {
              label: 'Homme',
              data: maleData,
              backgroundColor: color.homme,
            },
            {
              label: 'Femme',
              data: femaleData,
              backgroundColor: color.femme,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }

  setTotalAdmis_NoAdmisChart(
    canvasName: string,
    admisData: number,
    noAdmisData: number,
    title: string,
    colors: { Admis: string; NomAdmis: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Admis', 'Non admis'],
          datasets: [
            {
              label: 'My First Dataset',
              data: [this.countAdmis, this.countNoAdmis],
              backgroundColor: [
                'rgb(54, 162, 235)',
                'rgb(255, 99, 132)',
                // 'rgb(255, 205, 86)'
              ],
              hoverOffset: 4,
            },
          ],
        },

        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }

  // Diagmm Repartition du nmbre dadmis par famille de métier et par genre
  generateGenderChart() {
    this.utilisaterService
      .getAdmittedByFamilyAndGender()
      .pipe(
        tap((data) => {
          this.hommes.push(
            data?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Homme
          );
          this.hommes.push(data?.['E-BUSINESS']?.Homme);
          this.hommes.push(data?.['DÉVELOPPEMENT LOGICIEL']?.Homme);
          this.hommes.push(
            data?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Homme
          );

          this.femmes.push(
            data?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.Féminin
          );
          this.femmes.push(data?.['E-BUSINESS']?.Féminin);
          this.femmes.push(data?.['DÉVELOPPEMENT LOGICIEL']?.Féminin);
          this.femmes.push(
            data?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.Féminin
          );

          this.setGenderChart(
            'canvasFamily',
            this.hommes,
            this.femmes,
            "Répartition du nombre d'admis par famille de métier et par genre",
            {
              homme: 'rgba(75, 192, 192, 0.2)',
              femme: 'rgba(255, 99, 132, 0.2)',
            }
          );
        })
      )
      .subscribe();
  }
  // Méthode pour dessiner le diagramme Rpartition du nombre d'admis par famille de métier et par genre
  setGenderChart(
    canvasName: string,
    maleData: number[],
    femaleData: number[],
    title: string,
    colors: { homme: string; femme: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['IA/D', 'E-Bus', 'DEV-LOG', 'TE/Cybs'],
          datasets: [
            {
              label: 'Homme',
              data: maleData,
              backgroundColor: colors.homme,
              borderColor: 'rgb(54, 162, 235)',
              borderWidth: 1,
            },
            {
              label: 'Femme',
              data: femaleData,
              backgroundColor: colors.femme,
              borderColor: 'rgb(255, 99, 132)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }

  // Diagramme Repartition du nombre dadmis par famille de metier et par catégorie
  generateCategoryChart() {
    this.utilisaterService
      .getAdmittedByFamilyAndGender()
      .pipe(
        tap((dataGlobal) => {
          const c1Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.C1,
            dataGlobal?.['E-BUSINESS']?.C1,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C1,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.C1,
          ];

          const c2Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.C2,
            dataGlobal?.['E-BUSINESS']?.C2,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C2,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.C2,
          ];

          const c3Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.C3,
            dataGlobal?.['E-BUSINESS']?.C3,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C3,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.C3,
          ];

          const c4Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.C4,
            dataGlobal?.['E-BUSINESS']?.C4,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C4,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.C4,
          ];

          const c5Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.C5,
            dataGlobal?.['E-BUSINESS']?.C5,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C5,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.C5,
          ];

          const c6Data = [
            dataGlobal?.['INTELLIGENCE ARTIFICIELLE & DONNÉES']?.C6,
            dataGlobal?.['E-BUSINESS']?.C6,
            dataGlobal?.['DÉVELOPPEMENT LOGICIEL']?.C6,
            dataGlobal?.['TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE']?.C6,
          ];

          this.setCategoryChart(
            'canvasGlobal',
            c1Data,
            c2Data,
            c3Data,
            c4Data,
            c5Data,
            c6Data,
            "Répartition du nombre d'admis retenus par famille de métier et par catégorie",
            {
              c1: 'rgba(201, 203, 207, 0.2)',
              c2: 'rgba(75, 192, 192, 0.2)',
              c3: 'rgba(255, 205, 86, 0.2)',
              c4: 'rgba(255, 159, 64, 0.2)',
              c5: 'rgba(0, 128, 0, 0.2)',
              c6: 'rgba(255, 0, 255, 0.2)',
            }
          );
        })
      )
      .subscribe();
  }

  // Methode pour dessiner le diagramme Répartition du nombre dadmis par famille de métier et par catégorie
  setCategoryChart(
    canvasName: string,
    c1Data: number[],
    c2Data: number[],
    c3Data: number[],
    c4Data: number[],
    c5Data: number[],
    c6Data: number[],
    title: string,
    colors: {
      c1: string;
      c2: string;
      c3: string;
      c4: string;
      c5: string;
      c6: string;
    }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      this.chart2 = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['IA/D', 'E-Bus', 'DEV-LOG', 'TE/Cybs'],
          datasets: [
            {
              label: 'C1',
              data: c1Data,
              backgroundColor: colors.c1,
              borderColor: 'rgb(54, 162, 235)',
              borderWidth: 1,
            },
            {
              label: 'C2',
              data: c2Data,
              backgroundColor: colors.c2,
              borderColor: 'rgb(255, 99, 132)',
              borderWidth: 1,
            },
            {
              label: 'C3',
              data: c3Data,
              backgroundColor: colors.c3,
              borderColor: 'rgb(255, 205, 86)',
              borderWidth: 1,
            },
            {
              label: 'C4',
              data: c4Data,
              backgroundColor: colors.c4,
              borderColor: 'rgb(255, 159, 64)',
              borderWidth: 1,
            },
            {
              label: 'C5',
              data: c5Data,
              backgroundColor: colors.c5,
              borderColor: 'rgb(0, 128, 0)',
              borderWidth: 1,
            },
            {
              label: 'C6',
              data: c6Data,
              backgroundColor: colors.c6,
              borderColor: 'rgb(255, 0, 255)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }
}
